import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import Button from '@taglivros/oef_componentes/build/components/button'
import { bool, func, object, number } from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import { formatCEP, formatValor } from '../../../../utils/formatter/formatter'

const EnderecoVigente = styled.div`
  ${StyleGuide.tipografia.textoGrande};

  > .title {
    ${StyleGuide.boldFonte};
    color: ${StyleGuide.cores.cinza400};
  }

  p {
    margin: 0;
  }
`

const Modal = styled.div`
  background-color: ${StyleGuide.cores.branco};
  border-radius: 10px;
  margin: 0 auto;
  max-width: 500px;
  padding: 44px;
  position: relative;
  text-align: center;
  top: 50%;
  transform: translate3d(0, -50%, 0);
  z-index: 10;

  @media(max-width: ${StyleGuide.mediaQuery.smallpc}) {
    padding: 15px;
    width: 95%;
  }
`

const ModalWapper = styled.div`
  background-color: rgba(19, 26, 45, 0.5);
  display: ${( { open } ) => open ? 'block' : 'none'};
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 3;

  a,
  button {
    padding: 15px 28px;

    @media(max-width: ${StyleGuide.mediaQuery.tablet}) {
      width: 100%;
    }
  }

  button {
    @media(max-width: ${StyleGuide.mediaQuery.tablet}) {
      margin-bottom: 10px;
    }
  }
`

const Titulo = styled.h3`
  ${StyleGuide.tipografia.titulo3};
  color: ${StyleGuide.cores.cinza500};
  ${StyleGuide.boldFonte};
  margin: 25px 0;
`

const Descricao = styled.p`
  color: ${StyleGuide.cores.cinza500};
  ${StyleGuide.tipografia.textoPequeno};
  margin: 0;

  &:last-of-type {
    margin: 20px 0 50px;

    @media (max-width: ${StyleGuide.mediaQuery.tablet}) {
      margin: 20px 0 35px;
    }
  }
`

const WrapperButton = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 0 auto;
  max-width: 72%;

  @media( max-width: ${StyleGuide.mediaQuery.smallpc}) {
    max-width: 62%;
  }

  @media( max-width: ${StyleGuide.mediaQuery.mobile}) {
    max-width: 100%;
  }
`

const ModalConfirmaEndereco = ( { enderecoAdicionado, enderecoVigente, frete, open, onCancelar, onConfirmar } ) => {
  return (
    <ModalWapper open={ open }>
      <Modal>
        <EnderecoVigente>
          <p className="title">
            Atualmente, o endereço vigente é:
          </p>

          <p>
            { `${enderecoVigente.rua} ${enderecoVigente.numero}` }

            { enderecoVigente.complemento ? `/${enderecoVigente.complemento}...` : null}
          </p>
        </EnderecoVigente>

        <Titulo>
          Deseja alterar seu endereço de entrega para o novo endereço adicionado?
        </Titulo>

        <Descricao>
          { `${enderecoAdicionado.rua}, ${enderecoAdicionado.numero}` }
        </Descricao>

        <Descricao>
          { `${enderecoAdicionado.bairro} – ${enderecoAdicionado.cidade}/${enderecoAdicionado.uf}` }
        </Descricao>

        <Descricao>
          { `CEP: ${formatCEP( enderecoAdicionado.cep )}` }
        </Descricao>

        <Descricao>
          <span>
            { `Frete: ${formatValor( { 'valor': frete } )} ` }
          </span>
        </Descricao>

        <WrapperButton>
          <Button
            invertido
            onClick={ onCancelar }
            target="_self"
            tema={ Button.BOTAO_CURADORIA }
          >
            Cancelar
          </Button>

          <Button
            onClick={ onConfirmar }
            tema={ Button.BOTAO_CURADORIA }
          >
            Sim, alterar
          </Button>
        </WrapperButton>
      </Modal>
    </ModalWapper>
  )
}

ModalConfirmaEndereco.propTypes = {
  'enderecoAdicionado': object.isRequired,
  'enderecoVigente': object.isRequired,
  'frete': number.isRequired,
  'onCancelar': func,
  'onConfirmar': func,
  'open': bool
}

ModalConfirmaEndereco.defaultProps = {
  'onCancelar': () => {},
  'onConfirmar': () => {},
  'open': false
}

export default ModalConfirmaEndereco
